// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__YdClw","form":"styles_form__gNkPM","disclaimer":"styles_disclaimer__Sba3C"};